// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_EfHGW","title":"title_KmOsn","ui_mask":"ui_mask_wPVWF"};